export const cleanUpShortcut = (text: string) => {
  return text.replace(/[;\s]+/g, "");
};
